// Pont entre le consent-manager et GTM (skylantern).
// CommonJS volontaire : testable avec Node nu (test/consent-bridge.test.js), bundlé par webpack.
//
// CONSENT_HEAD_SNIPPET : copie du snippet `getHeadSnippet()` du package consent-manager
// (src/core/consent-mode-bridge.js), augmentée du drapeau window.__cmConsentDefaultSet
// que le tag GTM « Consent default filet » teste pour couvrir les pages HTML encore en
// cache CloudFront (ancien bundle sans snippet). Doit être rendu AVANT le script GTM.
const CONSENT_HEAD_SNIPPET =
  "(function(){var d={ad_storage:'denied',analytics_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',personalization_storage:'denied',functionality_storage:'granted',security_storage:'granted'};" +
  "try{var c=JSON.parse(localStorage.getItem('__cm_consent'));if(c&&c.c){if(c.c.analytics)d.analytics_storage='granted';if(c.c.marketing){d.ad_storage='granted';d.ad_user_data='granted';d.ad_personalization='granted'}if(c.c.personalization)d.personalization_storage='granted'}}catch(e){}" +
  'window.dataLayer=window.dataLayer||[];function g(){window.dataLayer.push(arguments)}window.gtag=g;' +
  "g('consent','default',d);g('set','url_passthrough',true);g('set','ads_data_redaction',d.ad_storage==='denied');" +
  'window.__cmConsentDefaultSet=true})();'

// Pousse une seule fois l'événement dataLayer que GTM utilise pour charger les tags
// conditionnés au consentement analytics (Hotjar). `cm.onConsent` exécute le callback
// immédiatement si la catégorie est déjà consentie, sinon à l'acceptation.
function buildConsentBridge (cm, dataLayer) {
  const state = { pushed: 0 }
  cm.onConsent('analytics', () => {
    if (state.pushed > 0) {
      return
    }
    state.pushed++
    dataLayer.push({ event: 'consent_analytics_granted' })
  })
  return state
}

// Le package place le bouton de réouverture en bas à GAUCHE, position codée en dur dans son
// CSS (`.cm-reopener { bottom: 16px; left: 16px }`) et non paramétrable par le thème. Sur
// skylantern.fr, la bulle de chat Tidio occupe ce coin sur grand écran : on recentre donc le
// bouton en bas au milieu. Surcharge locale au site, pour ne pas toucher Brumeaux ni Pokeo.
// Le survol du package applique `transform: scale(1.1)`, ce qui écraserait le recentrage :
// la règle de survol est donc redéfinie avec les deux transformations.
const REOPENER_CENTER_CSS =
  '.cm-reopener{left:50%;transform:translateX(-50%)}' +
  '.cm-reopener:hover{transform:translateX(-50%) scale(1.1)}'

// Ordre des boutons du bandeau. Le package les émet dans l'ordre « Tout refuser | Personnaliser |
// Tout accepter ». Sur mobile — 78 % du trafic — la feuille de style du package empile ces boutons
// verticalement en pleine largeur : l'ordre du DOM devient l'ordre vertical, et « Tout refuser » se
// retrouve donc en haut, à portée de pouce. Mesure du 03/09 : 14 % d'acceptation seulement.
// On réordonne en CSS (le conteneur `.cm-banner-actions` est en flex, en ligne comme en colonne),
// sans toucher au DOM du package, donc sans impact sur Brumeaux ni Pokeo.
//
// Conformité : la CNIL n'impose aucun ordre, mais exige que refuser soit aussi simple qu'accepter.
// Comme « Tout accepter » passe en premier ET reste le seul bouton en fond plein, on rééquilibre en
// donnant à « Tout refuser » une bordure franchement contrastée — la bordure d'origine (#1E2B47 sur
// un fond #06132F) était quasi invisible. Mêmes dimensions, même graisse, deux boutons lisibles.
const BANNER_BUTTONS_CSS =
  '.cm-btn-primary{order:1}' +
  '.cm-btn-link{order:2}' +
  '.cm-btn-secondary{order:3;border-color:#fff}'

// Injecte les surcharges du site dans le <head>. À appeler APRÈS l'initialisation de l'interface du
// package : à spécificité égale, c'est la règle la plus tardive qui gagne.
// Retourne true si l'injection a eu lieu, false si elle était déjà en place.
function injectSiteStyleOverrides (doc) {
  if (doc.getElementById('cm-site-overrides')) {
    return false
  }
  const style = doc.createElement('style')
  style.id = 'cm-site-overrides'
  style.textContent = REOPENER_CENTER_CSS + BANNER_BUTTONS_CSS
  doc.head.appendChild(style)
  return true
}

// Défaut du package (v1.0.0, commit c2d95ca) : `ConsentManager.init()` n'appelle `hideBanner()`
// que sur une action de l'utilisateur. Pour un visiteur revenant avec un choix déjà stocké,
// la bannière reste masquée — c'est voulu — mais le bouton de réouverture garde sa classe
// `cm-hidden` et n'apparaît jamais. Ce visiteur n'a donc plus AUCUN moyen de revenir sur son
// consentement, ce qu'exige le RGPD (retirer doit être aussi simple que donner).
// Correctif local au site ; le même défaut affecte Brumeaux et Pokeo.
// Retourne true si le bouton a été révélé.
function revealReopenerIfDecided (doc, choixStocke) {
  if (!choixStocke) {
    return false
  }
  const el = doc.querySelector('.cm-reopener')
  if (!el) {
    return false
  }
  el.classList.remove('cm-hidden')
  return true
}

module.exports = { CONSENT_HEAD_SNIPPET, buildConsentBridge, REOPENER_CENTER_CSS, BANNER_BUTTONS_CSS, injectSiteStyleOverrides, revealReopenerIfDecided }
